module.exports = __webpack_public_path__ + "671877584bf2fa40d5a5a06b45d245db.pdf";